// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/color-1","css/app"], () => (__webpack_require__("./resources/assets/app.js")))
__webpack_require__.O(undefined, ["css/color-1","css/app"], () => (__webpack_require__("./resources/assets/styles/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/color-1","css/app"], () => (__webpack_require__("./resources/assets/styles/color-1.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
